module.exports = __webpack_public_path__ + "img/violenceReport.11b6e2df.svg";